import { render, staticRenderFns } from "./wuju-feeling-list.vue?vue&type=template&id=1063f227&"
import script from "./wuju-feeling-list.vue?vue&type=script&lang=js&"
export * from "./wuju-feeling-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports